import styled from 'styled-components';

export const NewVariableArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  >div {
    flex-grow: 1;
    flex-basis: 0;
  }

  @media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
    flex-direction: column;
    >div {
      flex-grow: 1;
      flex-basis: unset;
    }
  }
`;

export const CheckBoxManadatory = styled.div`
  flex-grow: 0 !important;
  flex-basis: 0;
`;

export const AreaButton = styled.div`
  margin-top: 1rem;
  >button {
    margin-left: 0px;
    margin-right: 1rem;
  }
`;
